// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const spidops: PokeData = {
  "id": 918,
  "name": "spidops",
  "height": 10,
  "weight": 165,
  "base_experience": 141,
  "types": [
    PokeType.BUG
  ],
  "api_moves": [
    "headbutt",
    "tackle",
    "counter",
    "string-shot",
    "block",
    "feint",
    "assurance",
    "gastro-acid",
    "bug-bite",
    "circle-throw",
    "struggle-bug",
    "sticky-web",
    "throat-chop",
    "skitter-smack",
    "silk-trap"
  ],
  "moves": [
    "headbutt",
    "tackle",
    "string-shot",
    "bug-bite",
    "sticky-web",
    "signal-spam",
    "leech-steal",
    "pin-rush",
    "heal-order",
    "lunge",
    "pin-missile",
    "pounce",
    "infest"
  ],
  "evolution_chain": {
    "id": 482,
    "item": null,
    "species": [
      {
        "name": "tarountula",
        "order": 918,
        "types": [
          PokeType.BUG
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "spidops",
        "order": 919,
        "types": [
          PokeType.BUG
        ],
        "evolves_from_species_id": 917,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 15,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 149,
    "speed": 70,
    "ability_power": 158
  },
  "stat_changes": [],
  "catch_rate": 120,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
